import { Subject } from 'rxjs';
/** @internal */
export const STORE_EVENT_BUS = new Subject();
//# sourceMappingURL=storeEvents.js.map